import { cva } from 'class-variance-authority';

const tag = cva('border-2 border-separator px-3 py-1 rounded-full', {
  variants: {
    color: {
      orange: 'bg-orange-100 text-orange-500',
      red: 'bg-red-100 text-red-400',
      grey: 'bg-gray-200 text-gray-400',
      green: 'bg-green-100 text-green-400',
    },
  },
  defaultVariants: {
    color: 'orange',
  },
});

const RateTag = ({ label, color }) => {
  return <p className={tag({ color })}>{label}</p>;
};

export default RateTag;
